import React from 'react';
import PropTypes from "prop-types";

import moment from 'moment';

// react component for creating dynamic tables
import ReactTable from 'react-table';

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import { reactTableDefaultProps } from 'helpers/reactTable';

class DXFormSelectMember extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    const { currentOrg } = this.props.org;
    if (!currentOrg) {
      this.props.showAlertAction({
        message: '기관을 먼저 선택해주세요',
        color: 'danger',
      })
    } else {
      const org_id = currentOrg.id;
      if (this.unsubscribe) {
        this.unsubscribe();
      }
      this.unsubscribe = this.props.getMembersAction(org_id);
    }
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  isValidated = () => {
    return false;
  }

  render() {
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Assignment />
              </CardIcon>
              <h4 style={{
                ...cardTitle,
                marginTop: "15px",
                marginBottom: "0px",
                fontWeight: "bold"
              }}>대상자를 선택해주세요</h4>
            </CardHeader>
            <CardBody>
              <ReactTable
                {...reactTableDefaultProps}
                data={this.props.members}
                columns={[
                  {
                    id: 'name',
                    Header: "이름",
                    accessor: d => d.data().name
                  },
                  {
                    id: 'gender',
                    Header: "성별",
                    accessor: d => d.data().gender !== undefined
                      ? d.data().gender === 1
                        ? "남"
                        : "여"
                      : "미상"
                  },
                  {
                    id: 'age',
                    Header: "나이",
                    accessor: d => {
                      const { birthday: rawBirthday } = d.data();
                      const birthday = rawBirthday.constructor.name !== "String"
                        ? moment(birthday?.toDate())
                        : moment(rawBirthday);
                      return moment().diff(birthday, 'years')
                    }
                  },
                  {
                    id: "moved_in_at",
                    Header: "가입일",
                    accessor: d => {
                      const moved_in_at = d.data().moved_in_at;
                      return moment(moved_in_at ? moved_in_at.toDate() : null).format('YYYY-MM-DD')
                    }
                  },
                ]}
                getTrProps={(state, rowInfo) => {
                  if (rowInfo && rowInfo.row) {
                    return {
                      onClick: e => {
                        console.log("inside");
                        const uid = rowInfo.original.id;
                        const target = rowInfo.original.data();
                        this.props.setFormTarget({ ...target, uid, age: moment().diff(target.birthday, 'years') });
                        this.props.jumpToStep(1);
                        console.log(rowInfo);
                        if (rowInfo.index !== this.state.rowEdit) {
                          this.setState({
                            rowEdit: rowInfo.index
                          });
                        } else {
                          this.setState({
                            rowEdit: null
                          });
                        }
                        console.log(rowInfo.index);
                        console.log(this.state.rowEdit);
                      },
                      style: {
                        cursor: 'pointer'
                      }
                      // style: {
                      //   background:
                      //     rowInfo.index === this.state.rowEdit ? "#00afec" : "white",
                      //   color:
                      //     rowInfo.index === this.state.rowEdit ? "white" : "black"
                      // }
                    };
                  } else {
                    return {};
                  }
                }}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer >
    );
  }
}


DXFormSelectMember.propTypes = {
  classes: PropTypes.object
};


export default DXFormSelectMember;